import { httpClient } from '../httpClient';

export const attachmentHandler = (file, bucketPath) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('bucketPath', bucketPath);

  return httpClient
    .post(`/attachment`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    .then(response => {
      console.log('File uploaded successfully:', response.data);
      return response.data;
    })
    .catch(error => {
      console.error('File upload failed:', error);
      throw error;
    });
};
